import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export enum IDSubscribeTo {
  Genitori = '1',
  Padre = '2',
  Madre = '3',
  Altra = '5',
  Convivenza = '4',
}

const subscribeToList = Object.freeze([
  {
    id: IDSubscribeTo.Genitori,
    value: 'Famiglia dei genitori',
  },
  {
    id: IDSubscribeTo.Padre,
    value: 'Famiglia del padre',
  },
  {
    id: IDSubscribeTo.Madre,
    value: 'Famiglia della madre',
  },
  {
    id: IDSubscribeTo.Altra,
    value: 'Altra famiglia',
  },
  {
    id: IDSubscribeTo.Convivenza,
    value: 'Convivenza',
  },
]);

interface SubscribeToListProps {
  disabled?: boolean;
  error?: boolean;
  required?: boolean;
  isCohabitation: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
}

const SubscribeToListComponent = ({
  disabled,
  onChange,
  error,
  required,
  value,
  isCohabitation,
}: SubscribeToListProps): React.ReactElement => {
  const list = useMemo(() => {
    return subscribeToList.filter((element) =>
      isCohabitation
        ? element.id === IDSubscribeTo.Convivenza
        : element.id !== IDSubscribeTo.Convivenza
    );
  }, [isCohabitation]);
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="subscribe-to-list-label">
        {required ? "E' iscritto nella *" : "E' iscritto nella"}
      </InputLabel>
      <PmiSelect
        labelId="subscribe-to-list-label"
        id="subscribe-to-list"
        name="subscribe-to-list"
        value={value}
        label={required ? "E' iscritto nella *" : "E' iscritto nella"}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

SubscribeToListComponent.displayName = 'Subscribe to list component';

const SubscribeToList = memo(SubscribeToListComponent);

export default SubscribeToList as typeof SubscribeToListComponent;
